var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"vertical-export"},[_c('div',{staticClass:"contents"})])])])}]

export { render, staticRenderFns }